export default __webpack_public_path__ + "static/media/Congratulations.025af92b.svg";